/** Mirror IMS-Backend/src/constants/rfp.ts where needed in UI */
export const STATUS_NEEDS_MORE_INFORMATION = 'needs_more_information' as const;

/** Max stakeholders and business-head approvers on an RFP (and flow stakeholders). */
export const MAX_RFP_PARTICIPANTS = 5;
